// What a pound of wages really costs (Oct 2026). The business's labour cost basis decides:
// "gross_plus_oncosts" adds the on-cost rate (employer NI, pension, holiday), "gross" is
// wages alone. The same sum as the server's `finance.settings.labour_uplift`, so the rota's
// week cost agrees with Labour costs and the P&L.
export function labourUplift(settings, siteId) {
  if (!settings || settings.labour_cost_basis !== 'gross_plus_oncosts') return 1;
  // Each venue may set its own rate (the financial calendar's per-venue overrides, which the
  // settings response carries as `venues`). The server costs every shift at its own venue's
  // rate, so a screen that used one rate for the whole group disagreed with it.
  const venue = (siteId && (settings.venues || {})[siteId]) || null;
  // Otherwise the business's own rate. Not the flat `on_cost_pct`: the settings are fetched
  // for one venue, and that is *its* rate, so a Ludlow shift read under a Hereford header was
  // costed at Hereford's (review of #294). The flat one is for settings without the default.
  const raw = venue && venue.on_cost_pct != null
    ? venue.on_cost_pct
    : (settings.default_on_cost_pct != null ? settings.default_on_cost_pct : settings.on_cost_pct);
  const pct = Number(raw);
  return Number.isFinite(pct) && pct > 0 ? 1 + pct : 1;
}

/** "with 14% on-costs", "with 14-20% on-costs" where the venues differ, or nothing when the
 *  cost is wages alone. Takes one uplift or the ones a figure actually used. */
export function onCostWords(uplifts) {
  const pcts = [...new Set((Array.isArray(uplifts) ? uplifts : [uplifts])
    .map((u) => Math.round((Number(u) - 1) * 1000) / 10)
    .filter((p) => p > 0))].sort((a, b) => a - b);
  if (!pcts.length) return '';
  return pcts.length === 1
    ? `with ${pcts[0]}% on-costs`
    : `with ${pcts[0]}-${pcts[pcts.length - 1]}% on-costs`;
}
